export const italian = {
  feedback: {
    "title": "Invia feedback",
    "category": "Categoria",
    "suggestion": "Suggerimento",
    "problem": "Problema",
    "other": "Altro",
    "message": "Il tuo feedback",
    "placeholder": "Cosa miglioreresti o cosa non ha funzionato?",
    "email": "Email per una risposta (facoltativa)",
    "send": "Invia feedback",
    "sending": "Invio…",
    "success": "Grazie — il tuo feedback è stato ricevuto.",
    "error": "Impossibile inviare il feedback. Il testo è ancora qui; riprova.",
    "invalid": "Inserisci 10–3.000 caratteri e, se indicata, un’email valida.",
    "signIn": "Accedi per inviare feedback",
    "inbox": "Feedback utenti",
    "empty": "Nessun feedback al momento.",
    "reviewed": "Letto",
    "markReviewed": "Segna come letto",
    "refresh": "Aggiorna",
    "new": "Nuovo"
},
  menu: {
    signOut: "Disconnetti",
    signIn: "Accedi / Registrati",
    talkToUs: "Contattaci",
    language: "Lingua",
    deleteAccount: "Elimina Account",
    accountSettings: "Impostazioni Account",
  },
  theme: {
    light: "Chiaro",
    dark: "Scuro",
  },
  landing: {
    heroKicker: "Per cittadini e comuni in tutto il mondo",
    heroSub: "Consegniamo la tua voce al comune — in tutto il mondo.",
    municipalityLogin: "Accesso comuni",
    pecCardTitle: "Ogni segnalazione arriva ai comuni di tutto il mondo",
    pecBadge: "Email",
    pecCardBody: "Da qualsiasi città, in qualsiasi paese. I comuni partner ricevono i report direttamente; dove non c'è ancora un accordo, li inoltriamo via email alle autorità locali, perché nessun problema resti invisibile.",
    pecTitle: "Anche senza accordo, ogni segnalazione conta",
    pecBody: "Se il tuo comune non è ancora partner di ShapeIt, inviamo comunque ogni segnalazione via email, perché nessun problema resti invisibile.",
    pecHighlight: "Inviamo i report ai comuni tramite email",
    ctaSub: "Unisciti a cittadini e comuni di tutto il mondo: un report alla volta.",
  },
  mapHeader: {
    appName: "Shapeit",
    login: "Accedi / Registrati",
    searchPlaceholder: "Cerca un luogo o clicca ovunque sulla mappa per segnalare un problema",
    clearSearch: "Cancella ricerca",
  },
  mapLegend: {
    title: "Legenda Shapeit",
    buttonLabel: "Legenda",
    dirty: "Sporco",
    unsafe: "Pericoloso",
    needsFix: "Da Riparare",
  },
  dialog: {
    selectLanguage: "Seleziona la tua lingua preferita",
    chooseLanguage: "Scegli una lingua per l'interfaccia dell'applicazione.",
    confirm: "Conferma",
    welcome: {
      title: "Benvenuto!",
      message: "Shapeit è qui per darti potere, vogliamo che tu possa modellare la tua città e trasformarla in un posto migliore. Ogni volta che noti un problema puoi segnalarlo e puoi anche mettere mi piace alle segnalazioni di altri utenti per dar loro maggiore visibilità. Da parte nostra, ci assicureremo di tenere le autorità cittadine aggiornate sui problemi più urgenti.",
      message2: "Shapeit sta lavorando per collaborare con municipalità in tutto il mondo. Anche se il tuo comune non è ancora nostro partner, inviamo ogni segnalazione al comune tramite email, perché nessun problema resti invisibile. Ogni report contribuisce a creare un database aggiornato dei problemi urbani della tua città: più segnalazioni raccogliamo, più forte sarà la nostra voce quando ci presenteremo alle autorità locali. Ora vai e rendi la tua città un posto migliore!",
      next: "Avanti",
      button: "Iniziamo!"
    }
  },
  reports: {
    overview: "Panoramica Segnalazioni",
    trending: "Di Tendenza",
    myReports: "Le Mie Segnalazioni",
    yourReports: "Le Tue Segnalazioni",
    recentReports: "Segnalazioni Recenti",
    by: "da",
    anonymous: "Anonimo",
  },
  usernameSetup: {
    title: "Scegli il tuo nome utente",
    description: "Scegli un nome pubblico mostrato sulle tue segnalazioni. Puoi cambiarlo dalle impostazioni account.",
    placeholder: "Il tuo nome utente",
    save: "Salva",
    saving: "Salvataggio...",
    skip: "Più tardi",
    tooShort: "Il nome utente deve avere almeno 2 caratteri",
    noEmail: "Il nome utente non può contenere @",
    success: "Nome utente salvato",
    error: "Impossibile salvare il nome utente",
  },
  reportForm: {
    postAnonymously: "Pubblica in anonimo",
    postAnonymouslyHint: "Il tuo nome non sarà mostrato su questa segnalazione.",
    postingAs: "Pubblichi come",
    title: "Invia una Segnalazione",
    description: "Descrizione",
    uploadPhoto: "Carica Foto",
    takePhoto: "Scatta Foto",
    changePhoto: "Cambia Foto",
    preview: "Anteprima",
    submit: "Invia Segnalazione",
    submitting: "Invio in corso...",
    loginRequired: "Devi accedere per inviare una segnalazione",
    uploadFailed: "Impossibile caricare la segnalazione",
    photoUploadFailed: "Non è stato possibile inviare la foto. La segnalazione è ancora qui.",
    sendWithoutPhoto: "Invia senza foto",
    selectIssue: "Seleziona un tipo di problema",
    selectIssueType: "Seleziona un tipo di problema",
    moderationWarning: "I report vengono moderati automaticamente. Contenuti offensivi, spam o inappropriati saranno rifiutati.",
    rejectedContent: "Il tuo report contiene contenuti inappropriati e non può essere pubblicato",
    rateLimitExceeded: "Hai raggiunto il limite di 5 report all'ora. Riprova più tardi.",
    characterLimit: "La descrizione non può superare i 500 caratteri",
    appealLink: "Invia appello via email",
    offensiveContent: "Il tuo messaggio contiene linguaggio non appropriato",
    validatingImage: "Verifica immagine in corso...",
        aiAnalyzing: "AI sta analizzando...",
    duplicateWarning: "Report simile già esistente nelle vicinanze. Considera di dare upvote invece di creare un duplicato.",
    aiSuggestions: "Suggerimenti AI",
    suggestedTitle: "Titolo suggerito:",
    priority: "Priorità:",
    inappropriateImage: "L'immagine contiene contenuti non appropriati e non può essere utilizzata",
    notRelevantImage: "La foto non sembra mostrare un problema urbano. Carica una foto del problema che vuoi segnalare.",
  },
  confirmReport: {
    question: "Vuoi creare una segnalazione qui?",
    yes: "Sì",
    no: "No"
  },
  locationPrompt: "Clicca sul punto desiderato per segnalare un problema",
  reportHere: "Segnala qui",
  deleteAccount: {
    title: "Elimina Account",
    warning: "Questa azione è irreversibile!",
    description: "Tutti i tuoi dati verranno eliminati permanentemente, inclusi:",
    items: {
      reports: "Tutte le tue segnalazioni",
      photos: "Tutte le foto caricate",
      accountData: "Le informazioni del tuo account"
    },
    confirmLabel: "Digita DELETE per confermare",
    confirmPlaceholder: "DELETE",
    cancel: "Annulla",
    deleteButton: "Elimina il Mio Account",
    deleting: "Eliminazione in corso...",
    success: "Account eliminato con successo",
    error: "Impossibile eliminare l'account"
  },
  gamification: {
    totalReports: "Segnalazioni totali",
    congratulations: "Congratulazioni!",
    pointsEarned: "Punti guadagnati",
    totalPoints: "Punti totali",
    currentLevel: "Livello attuale",
    levelUp: "Nuovo Livello!",
    nextLevel: "Prossimo livello",
    progress: "Progresso",
    thankYou: "Grazie per rendere la città un posto migliore!",
    keepGoing: "Continua a segnalare per raggiungere il prossimo livello!",
    continue: "Continua",
    levels: {
      beginner: "Principiante",
      active_citizen: "Cittadino Attivo",
      urban_observer: "Osservatore Urbano",
      city_guardian: "Guardiano della Città",
      civic_champion: "Campione Civico",
      urban_hero: "Eroe Urbano"
    },
    messages: {
      beginner: "Benvenuto nella comunità!",
      active_citizen: "Stai facendo la differenza!",
      urban_observer: "I tuoi occhi rendono la città migliore!",
      city_guardian: "Sei un vero guardiano!",
      civic_champion: "Campione del dovere civico!",
      urban_hero: "Sei un eroe urbano!"
    }
  },
  onboarding: {
    step1: {
      title: "Benvenuto sulla Mappa!",
      description: "Qui puoi vedere tutte le segnalazioni della tua comunità. Impariamo come usarla!"
    },
    step2: {
      title: "Crea una Segnalazione",
      description: "Cerca un luogo o clicca sulla mappa per creare una nuova segnalazione su un problema nella tua zona."
    },
    step3: {
      title: "Tipi di Segnalazione",
      description: "Colori diversi rappresentano tipi diversi di problemi. Clicca sui marker per vedere i dettagli e dare upvote alle segnalazioni che ti interessano!"
    },
    step4: {
      title: "Il Tuo Profilo & Gamification",
      description: "Guadagna punti creando segnalazioni e aiutando la tua comunità! Monitora il tuo livello e i progressi qui."
    },
    step5: {
      title: "Sei Pronto!",
      description: "Inizia a migliorare la tua comunità segnalando problemi e interagendo con altre segnalazioni. Ogni contributo conta!"
    },
    previous: "Precedente",
    next: "Avanti"
  },
    accountSettings: {
    title: "Impostazioni Account",
    openSettings: "Impostazioni Account",
    changeEmail: "Cambia Email",
    newEmailLabel: "Nuovo indirizzo email",
    newEmailPlaceholder: "nuova@email.com",
    changePassword: "Cambia Password",
    newPasswordLabel: "Nuova password",
    newPasswordPlaceholder: "Almeno 6 caratteri",
    passwordTooShort: "La password deve avere almeno 6 caratteri",
    passwordSuccess: "Password aggiornata con successo",
    changeUsername: "Cambia Username",
    newUsernameLabel: "Nuovo username",
    newUsernamePlaceholder: "Il tuo username",
    usernameTooShort: "L'username deve avere almeno 2 caratteri",
    usernameSuccess: "Username aggiornato con successo",
    deleteAccountTitle: "Elimina Account",
    deleteAccountDescription: "Elimina definitivamente il tuo account e tutti i dati correlati. Questa azione non può essere annullata.",
    deleteAccountButton: "Elimina account",
    save: "Salva",
    saving: "Salvataggio...",
    submit: "Invia email di conferma",
    submitting: "Invio in corso...",
    invalidEmail: "Email non valida",
    error: "Errore",
    updateFailed: "Impossibile aggiornare",
    successTitle: "Email di verifica inviata",
    successDescription: "Abbiamo inviato un'email di conferma a {email}. Controlla la tua casella per confermare il cambio.",
    showPassword: "Mostra password",
    hidePassword: "Nascondi password",
  },
  push: {
    title: "Notifiche Push",
    subtitle: "Gestisci le notifiche che ricevi sul tuo dispositivo",
    enable: "Abilita notifiche push",
    denied: "Permesso negato. Abilita le notifiche nelle impostazioni del dispositivo.",
    registered: "Dispositivo registrato",
    requestPermission: "Richiedi il permesso per ricevere notifiche",
    resolved: "Report risolto",
    resolvedDesc: "Quando una tua segnalazione viene risolta",
    upvotes: "Upvote ricevuti",
    upvotesDesc: "Quando qualcuno mette un upvote ai tuoi report",
    achievements: "Achievement sbloccati",
    achievementsDesc: "Quando sblocchi un nuovo achievement",
    newReports: "Nuovi report",
    newReportsDesc: "Quando vengono creati nuovi report",
    updated: "Preferenze aggiornate",
    updateError: "Errore nell'aggiornamento delle preferenze",
    mobileOnly: "Le notifiche push vengono inviate nell'app mobile",
  },
  referral: {
    inviteTitle: "Invita amici e guadagna punti!",
    inviteSubtitle: "Crea il tuo codice invito per iniziare a guadagnare 50 punti per ogni amico che si iscrive.",
    createCode: "Crea codice invito",
    yourCode: "Il tuo codice invito",
    copy: "Copia",
    codeCopied: "Codice copiato negli appunti!",
    linkCopied: "Link di invito copiato!",
    directLink: "Link diretto",
    stats: "Statistiche inviti",
    completed: "Completati",
    pending: "In attesa",
    total: "Totale",
    ambassadorProgress: "Progresso Ambasciatore",
    ambassadorUnlocked: "Hai sbloccato il badge Ambasciatore!",
    shareText: "Unisciti a ShapeIt e aiuta a migliorare la tua città! Usa il mio codice {code} per ricevere 50 punti bonus 🎁",
    shareTitle: "Invito ShapeIt",
  },
  misc: {
    mapLoadFailed: "Impossibile caricare la mappa",
    mapKeyError: "Impossibile caricare la chiave API di Google Maps",
    mapKeyMissing: "Chiave API di Google Maps non configurata",
    mapsLoadError: "Impossibile caricare Google Maps",
    onlyImages: "Sono consentite solo immagini JPEG, PNG e WebP",
    imageTooLarge: "L'immagine deve essere inferiore a 5MB",
    photoFailed: "Impossibile scattare la foto",
    current: "Attuale",
    progress: "Progresso",
  },
  common: {
    share: "Condividi",
    shareTitle: "Condividi questa segnalazione",
    copyLink: "Copia link",
    linkCopied: "Link copiato negli appunti!",
    copyFailed: "Copia del link non riuscita",
    loading: "Caricamento...",
    close: "Chiudi",
    delete: "Elimina",
    cancel: "Annulla",
    retry: "Riprova",
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    username: "Nome utente",
    anonymous: "Anonimo",
    notYourReport: "Non è la tua segnalazione",
    loginToDelete: "Accedi per eliminare",
    upvotes: "Voti",
    reportedBy: "Segnalato da",
    trending: "In tendenza",
    trendingReports: "Segnalazioni in tendenza",
    noTrending: "Nessuna segnalazione in tendenza",
    yourReports: "Le tue segnalazioni",
    noReportsYet: "Non hai ancora creato segnalazioni",
    loadingAddress: "Caricamento indirizzo…",
    myLocation: "La mia posizione",
    yourLocation: "La tua posizione",
    mapView: "Vista mappa",
    satelliteView: "Vista satellite",
    changePhoto: "Cambia foto",
    uploadingPhoto: "Caricamento...",
    photoUpdated: "Foto profilo aggiornata",
    photoUploadError: "Impossibile caricare la foto",
    removePhoto: "Rimuovi foto",
    inviteFriends: "Invita amici",
    achievements: "Obiettivi",
    noAchievements: "Nessun obiettivo sbloccato",
    statusHistory: "Cronologia stato",
    seeTranslation: "Mostra traduzione",
    seeOriginal: "Mostra originale",
    translating: "Traduzione in corso...",
    translationFailed: "Traduzione non disponibile",
    translatedAutomatically: "Tradotto automaticamente",
    deleteConfirm: "Vuoi eliminare questa segnalazione?",
    loginToDeleteReports: "Accedi per eliminare le segnalazioni",
    onlyOwnReports: "Puoi eliminare solo le tue segnalazioni",
  },
  auth: {
    backToMap: "Torna alla mappa",
    subtitle: "Accedi o crea un account per segnalare problemi nella tua comunità",
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    username: "Nome utente",
    orContinueWith: "Oppure continua con",
    signInGoogle: "Accedi con Google",
    signUpGoogle: "Registrati con Google",
    signingIn: "Accesso in corso...",
    signIn: "Accedi",
    referralLabel: "Codice invito (opzionale) 🎁",
    referralPlaceholder: "Inserisci un codice invito",
    referralBonus: "Riceverai 50 punti bonus con questo codice! 🎁",
    creatingAccount: "Creazione account...",
    createAccount: "Crea account",
    showPassword: "Mostra password",
    hidePassword: "Nascondi password",
  },
  analytics: {
    otherCategory: "Altro",
    pageTitle: "Dashboard Analytics",
    pageSubtitle: "Statistiche pubbliche e trasparenza sulle segnalazioni della community",
    backToMap: "Torna alla mappa",
    noData: "Nessun dato disponibile",
    communityTitle: "Analytics della community",
    communitySubtitle: "Statistiche in tempo reale sulle segnalazioni civiche",
    municipalityScopedSubtitle: "Statistiche in tempo reale sulle segnalazioni del tuo comune",
    totalReports: "Totale segnalazioni",
    inProgress: "In corso",
    resolved: "Risolte",
    avgTime: "Tempo medio",
    categoryTitle: "Distribuzione per categoria",
    categoryDesc: "Tipologie di segnalazioni ricevute",
    trendTitle: "Trend ultimi 7 giorni",
    trendDesc: "Numero di segnalazioni giornaliere",
    topAreasTitle: "Zone più segnalate",
    topAreasDesc: "Le aree con più segnalazioni attive",
    adminTitle: "Analytics avanzati (Admin)",
    adminSubtitle: "Metriche dettagliate visibili solo agli amministratori",
    dau: "Utenti attivi giornalieri",
    wau: "Utenti attivi settimanali",
    mau: "Utenti attivi mensili",
    avgSession: "Durata media sessione",
    minutesShort: "min",
    mapInteractions: "Interazioni mappa",
    perSession: "Media per sessione",
    reportsPerUser: "Segnalazioni per utente",
    average: "Media",
    completionRate: "Tasso completamento",
    loginToReport: "Login → Segnalazione",
    funnelTitle: "Funnel di conversione",
    funnelDesc: "Analisi del percorso utente (ultimi 7 giorni)",
    users: "Utenti",
    conversionPct: "% Conversione",
    devicesTitle: "Distribuzione dispositivi",
    devicesDesc: "Analisi dei dispositivi utilizzati",
  },
};
